var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"member_counter my-5",attrs:{"id":"s513-animated-counter"}},[_c('b-col',{staticClass:" bg-dark",attrs:{"lg":"12"}},[_c('b-container',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }